// import { useContext } from 'preact/hooks';
import { Match, Link } from 'preact-router/match';
import { Text } from 'preact-i18n';

import {
  HomeIcon, SettingsIcon, MoreIcon,
} from '@svg';

// import { Context } from '@store';

import style from './style.module.scss';

function BottomNavBar() {
  // const [{ isTWA, patron }] = useContext(Context);

  const showBottomNavBar = (path) => {
    if (!path) return false;
    return path !== '/:id';
  };

  return (
    <Match>
      {({ path }) => showBottomNavBar(path) && (
        <nav class={style.nav}>
          <Link href="/" activeClassName={style.active} class={style.nav_item}>
            <div class={style.nav_item_icon}>
              <HomeIcon />
            </div>
            <span>
              <Text id="general.home">Home</Text>
            </span>
          </Link>
          <Match path="/settings">
            {({ path: settingPath, url }) => (settingPath.startsWith('/settings/') ? (
              <Link
                href="/settings"
                activeClassName={style.active}
                path={url}
                class={style.nav_item}
              >
                <div class={style.nav_item_icon}>
                  <SettingsIcon />
                </div>
                <span>
                  <Text id="general.settings">Settings</Text>
                </span>
              </Link>
            ) : (
              <Link
                href="/settings"
                activeClassName={style.active}
                class={style.nav_item}
              >
                <div class={style.nav_item_icon}>
                  <SettingsIcon />
                </div>
                <span>
                  <Text id="general.settings">Settings</Text>
                </span>
              </Link>
            ))}
          </Match>
          <Link href="/more" activeClassName={style.active} class={style.nav_item} aria-label="Learn more">
            <div class={style.nav_item_icon}>
              <MoreIcon />
            </div>
            <span>
              <Text id="general.more">More</Text>
            </span>
          </Link>
          {/* { !isTWA && (
            <Link
              href="/patreon"
              activeClassName={style.active}
              class={`${style.nav_item}`}
              id={patron ? style.patron : style.support_us}
            >
              <div class={style.nav_item_icon}>
                { patron ? <AccountIcon /> : <RedeemIcon /> }
              </div>
              { patron
                ? <span><Text id="general.account">Account</Text></span>
                : <span><Text id="general.support_us">Support Us</Text></span>}
            </Link>
          )} */}
        </nav>
      )}
    </Match>
  );
}

export default BottomNavBar;
